export interface ColorScheme {
  backgroundColor: string;
  primaryColor: string;
}

export const generateColor = (
  index: number,
  backgroundOpacity = 90,
): ColorScheme => {
  const hue = (index * 137.5) % 360;

  return {
    backgroundColor: `hsl(${hue}, 70%, ${backgroundOpacity.toString()}%)`,
    primaryColor: `hsl(${hue}, 70%, 40%)`,
  };
};
